document.addEventListener('DOMContentLoaded', () => {
  
  // 1. Event Delegation attached to the body
  document.body.addEventListener('click', async (e) => {
    
    // 2. Intercept the click on our custom category buttons
    const button = e.target.closest('.collection-morph-btn');
    if (!button) return;

    e.preventDefault();

    // Prevent action if they click the active category
    if (button.classList.contains('active-luxury-filter')) return;

    const targetHandle = button.getAttribute('data-target-handle');
    
    // 3. TARGETING THE NATIVE DOM
    // We surgically target the exact container holding your product grid
    const productGridContainer = document.querySelector('.collection-listing');
    
    // We need the section ID to tell Shopify's server what part of the page to return
    const filterContainer = document.querySelector('[data-filter-section-id]');

    // The Fail-Safe: If for some reason the grid doesn't exist, do a hard redirect
    if (!productGridContainer || !filterContainer) {
      window.location.href = `/collections/${targetHandle}`;
      return;
    }

    const sectionId = filterContainer.getAttribute('data-filter-section-id');

    // 4. Trigger the Luxury Loading State on the grid ONLY
    productGridContainer.style.opacity = '0.3';
    productGridContainer.style.pointerEvents = 'none';
    productGridContainer.style.transition = 'opacity 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

    try {
      // 5. The Asynchronous Fetch
      const fetchUrl = `/collections/${targetHandle}?section_id=${sectionId}`;
      const response = await fetch(fetchUrl);
      
      if (!response.ok) throw new Error('Network response failed');

      const htmlText = await response.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(htmlText, 'text/html');

      // 6. Extract ONLY the newly rendered product grid
      const newProductGrid = newDoc.querySelector('.collection-listing');

      if (newProductGrid) {
        // 7. Inject the new products directly into the background
        productGridContainer.innerHTML = newProductGrid.innerHTML;
        
        // 8. Restore visibility smoothly
        productGridContainer.style.opacity = '1';
        productGridContainer.style.pointerEvents = 'auto';

        // 9. Update the URL state seamlessly without reloading the browser
        window.history.pushState({ path: `/collections/${targetHandle}` }, '', `/collections/${targetHandle}`);

        // 10. Update the Active UI State in the Sidebar instantly
        document.querySelectorAll('.collection-morph-btn').forEach(btn => {
          btn.classList.remove('active-luxury-filter');
          if (btn.getAttribute('data-target-handle') === targetHandle) {
            btn.classList.add('active-luxury-filter');
          }
        });

      } else {
        throw new Error('New product grid not found in the fetched response');
      }

    } catch (error) {
      console.error('Tycoon Router Failed (Executing Fallback):', error);
      // Hard fallback to standard navigation if the fetch fails
      window.location.href = `/collections/${targetHandle}`;
    }
  });

  // Handle browser back/forward buttons cleanly
  window.addEventListener('popstate', () => {
    window.location.reload(); 
  });
});